import React from "react";
import VoteItem from "./components/VoteItem";
import style from "./index.module.scss";

interface OptionsProps {
    data: {
        count: number;
        text: string;
    }[];
    total: number;
}

export default function Options({ data, total }: OptionsProps) {
    return (
        <div className={style.root}>
            {data.map(item => (
                <VoteItem
                    key={item.text}
                    text={item.text}
                    total={total}
                    count={item.count}
                />
            ))}
        </div>
    );
}
